<template>
	<div>
		<template v-if="$route.params.withdraw == 'pay'">
			<pepparaForm />
			<br />
			<h4 class="mt-2">Güncel Peppara hesaplarımızı lütfen Canlı Destek üzerinden isteyiniz.</h4>
		</template>
		<template v-if="$route.params.withdraw == 'withdraw'">
			<pepparaWithdraw />
		</template>
	</div>
</template>

<script>
    import pepparaForm from '@/components/payments/form/peppara'
    import pepparaWithdraw from '@/components/payments/form/pepparaWithdraw'
    export default {
        name: "peppara",
        components: {pepparaWithdraw, pepparaForm}
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/payments/gateways/peppara.vue